import { render } from "./GoalsManagement.vue?vue&type=template&id=6be69264&scoped=true"
import script from "./GoalsManagement.vue?vue&type=script&lang=js"
export * from "./GoalsManagement.vue?vue&type=script&lang=js"

import "./GoalsManagement.vue?vue&type=style&index=0&id=6be69264&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be69264"]])

export default __exports__